import { render, staticRenderFns } from "./CreateCommentWrapper.vue?vue&type=template&id=5da11298"
import script from "./CreateCommentWrapper.vue?vue&type=script&lang=js"
export * from "./CreateCommentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports